import LaunchIcon from '@mui/icons-material/Launch';
import { Box, Typography } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import { FC, ReactNode } from 'react';
import { sxs } from '@utils/mui/sx';

export type ArrowPosition = 'left' | 'right';

export type ComponentColor = 'primary' | 'black';

interface ArrowButtonSx {
    arrowIcon: {
        mt: string;
        mx: number;
        width: (th: Theme) => string;
    };
    link: {
        '& :hover': {
            textDecoration: string;
        };
        alignItems: string;
        cursor: string;
        display: string;
        mt: number;
        pr: number;
        py: number;
    };
}

const arrowButtonSx: ArrowButtonSx = {
    arrowIcon: {
        mt: '1px',
        mx: 1,
        width: (th) => th.spacing(2),
    },
    link: {
        '& :hover': {
            textDecoration: 'underline',
        },
        alignItems: 'center',
        cursor: 'pointer',
        display: 'inline-flex',
        mt: 1,
        pr: 1,
        py: 1,
    },
};

interface ArrowButtonProps {
    arrowPosition?: ArrowPosition;
    children?: ReactNode;
    componentColor?: ComponentColor;
    isExternal?: boolean;
    isLoading?: boolean;
    label?: string;
    onClick?: () => void;
    sx?: SxProps<Theme>;
}

const ArrowButton: FC<ArrowButtonProps> = ({
    arrowPosition = 'right',
    children,
    componentColor = 'primary',
    isExternal,
    isLoading,
    label,
    onClick,
    sx = {},
}) => {
    const linkIcon = `/assets/arrow_${arrowPosition}_${
        isLoading ? 'disabled' : componentColor
    }.svg`;

    const getColor = (): string => {
        if (isLoading) return 'text.disabled';

        return componentColor === 'black' ? 'secondary.main' : 'primary.main';
    };

    return (
        <Box onClick={onClick} sx={sxs([arrowButtonSx.link, { color: getColor() }, sx])}>
            {label ? <Typography sx={{ fontWeight: 'bold' }}>{label}</Typography> : children}
            {isExternal ? (
                <LaunchIcon fontSize="small" sx={{ ml: 1 }} />
            ) : (
                <Typography alt="" component="img" src={linkIcon} sx={arrowButtonSx.arrowIcon} />
            )}
        </Box>
    );
};

export default ArrowButton;
